import '../assets/NcCheckboxRadioSwitch-CaAqi0Jt.css';
import { r } from "./_l10n-BaNxGGXy.mjs";
r();
